import React, { useState, useEffect } from 'react';
import FormModalWrapper from './FormModal.styles';
import IntlMessages from '@iso/components/utility/intlMessages';
import { Form, Input, Button, Select, Row, Col } from 'antd';
import _ from 'lodash';
import { surveyQuestionService } from '@iso/services';
import { surveyQuestionTypes } from '@iso/constants/surveyQuestionTypes';
import QuestionFields from './QuestionFields';

const { Option } = Select;

const QuestionModal = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [questionType, setQuestionType] = useState(null);
  const [dataQuestion, setDataQuestion] = useState({});
  const [isCheckinForm, setIsCheckinForm] = useState(false);
  const [visitorTypes, setVisitorTypes] = useState([]);
  
  useEffect(() => {
    if(props.questionData)
    {
      setDataQuestion(props.questionData);
      setQuestionType(props.questionData.question_type);
      form.setFieldsValue({
        'survey_question': {
          'title': props.questionData.title,
          'question_type': props.questionData.question_type,
          'meta_data': props.questionData.meta_data,
        }
      });
      // form.setFields([
      //   {
      //     name: ['survey_question', 'title'],
      //     value: dataQuestion.title,
      //   },
      //   {
      //     name: ['survey_question', 'question_type'],
      //     value: dataQuestion.question_type,
      //   },
      //   {
      //     name: ['survey_question', 'meta_data'],
      //     value: dataQuestion.meta_data,
      //   },
      // ]);
    }
    
  }, [props.visibilityQuestionModal, dataQuestion,props.questionData]);

  useEffect(() => {
    setIsCheckinForm(props.form?.form?.is_checkin_form || false);
    setVisitorTypes(props.form?.form?.meta_data?.visitor_types || []);
  }, [props.form]);

  const handleSubmit = (e) => {
    setLoading(true);

    form
      .validateFields()
      .then(values => {
        onStore(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
        setLoading(false);
      });
  }

  const onStore = (values) => {
    const data = {
      "survey_question":{
        ...values.survey_question,
        form_id: props.formId
      }
    }

    surveyQuestionService.storeOrUpdate(data, dataQuestion.id).then(res => {
      if(res.code === '0000'){
        cancelModal();
        props.updateQuestionData();

      } else {
        setLoading(false);
      }
    });
  }

  const cancelModal = () => {
    props.cancelQuestionModal();
    form.resetFields();
    setLoading(false);
  }

  const renderOptionsSurveyQuestion = () => {
    let options = [];
    _.forEach(surveyQuestionTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
            <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a question type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  return (
     <FormModalWrapper
      visible={props.visibilityQuestionModal}
      onCancel={cancelModal}
      centered
      title={ dataQuestion.id ? <IntlMessages id="formPage.modal.editQuestionModal.title"/> : <IntlMessages id="formPage.modal.addQuestionModal.title"/> }
      footer={[        
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
    {
    
          <Form
            form={form}
            layout="vertical"
            scrollToFirstError
          >
          <div className="form-body">
            {/* <Form.Item
              name={['survey_question', 'title']}
              className="isoInputWrapper"
              label="Title"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item
              name={['survey_question', 'question_type']}
              className="isoInputWrapper"
              label="Question Type"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionsSurveyQuestion()}
            </Form.Item> */}
           <QuestionFields
              name={['survey_question']}
              questionType={questionType}
              isCheckinForm={isCheckinForm}
              visitorTypes={visitorTypes}
              questionData={dataQuestion}
            />
          </div>    
      </Form>
    }
    </FormModalWrapper>
  )
}

export default QuestionModal;